import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('graphql'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  avatarPath: avatars.graphql,
  logoPath: logos.graphql
});
